import * as Yup from 'yup';

export const restoreFormByEmail = Yup.object().shape({
  email: Yup.string()
    .required('formForgotPassword.emptyEmailError')
    .email('formForgotPassword.invalidEmail')
    .nullable(),
});

export const restoreFormPassword = Yup.object().shape({
  password: Yup.string()
    .required('formRegistration.passwordError')
    .min(10, 'formRegistration.passwordErrorMin')
    .max(20, 'formRegistration.passwordErrorMax')
    .matches(/[a-z]/, 'formRegistration.passwordErrorLower')
    .matches(/[0-9]/, 'formRegistration.passwordErrorNumber'),
  confirmPassword: Yup.string()
    .required('formRegistration.confirmPasswordError')
    .oneOf([Yup.ref('password')], 'formRegistration.confirmPasswordError'),
});
